"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationLogEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const PushNotificationLogDto_1 = require("./PushNotificationLogDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class PushNotificationLogEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, pushNotificationLogs) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            locationId: false,
            locationName: false,
            subject: false,
            totalNotificationsSent: false,
            messageInformation: false
        };
        this._dependencies = dependencies;
        if (pushNotificationLogs === undefined) {
            this._dto = new PushNotificationLogDto_1.PushNotificationLogDto();
        }
        else if (pushNotificationLogs instanceof PushNotificationLogDto_1.PushNotificationLogDto) {
            this._dto = new PushNotificationLogDto_1.PushNotificationLogDto(pushNotificationLogs);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (pushNotificationLogs instanceof PushNotificationLogEntity) {
            this._dto = new PushNotificationLogDto_1.PushNotificationLogDto(pushNotificationLogs._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new PushNotificationLogDto_1.PushNotificationLogDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getLocationName() {
        return this._dto.locationName;
    }
    setLocationName(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("locationName");
        this._requiredFieldsSetStatus.locationName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("locationName", "Location Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("locationName", `Location Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationName) {
            return;
        }
        this._dto.locationName = _untrustedValue;
        this._setIsDirty(true);
    }
    getSubject() {
        return this._dto.subject;
    }
    setSubject(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("subject");
        this._requiredFieldsSetStatus.subject = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("subject", "Subject is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("subject", `Subject has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.subject) {
            return;
        }
        this._dto.subject = _untrustedValue;
        this._setIsDirty(true);
    }
    getTotalNotificationsSent() {
        return this._dto.totalNotificationsSent;
    }
    setTotalNotificationsSent(untrustedValue) {
        let _untrustedValue;
        this.clearError("totalNotificationsSent");
        this._requiredFieldsSetStatus.totalNotificationsSent = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("totalNotificationsSent", "Total Notifications Sent is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("totalNotificationsSent", "Total Notifications Sent is required."));
        }
        else if (_untrustedValue <= 0) {
            this.addError(new ValidationError_1.ValidationError("totalNotificationsSent", "Total Notifications Sent must be greater then 0."));
        }
        if (!this.isNew && _untrustedValue === this._dto.totalNotificationsSent) {
            return;
        }
        this._dto.totalNotificationsSent = _untrustedValue;
        this._setIsDirty(true);
    }
    getMessageInformation() {
        return this._dto.messageInformation;
    }
    setMessageInformation(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("messageInformation");
        this._requiredFieldsSetStatus.messageInformation = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("messageInformation", "Message Information is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("messageInformation", `Message Information has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.subject) {
            return;
        }
        this._dto.messageInformation = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.pushNotificationLogDatastore
                    .getAsync(id, expand);
                delete this._locationEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Push Notification Logs is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.pushNotificationLogDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.pushNotificationLogDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Push Notification Logs cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.pushNotificationLogDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.PushNotificationLogEntity = PushNotificationLogEntity;
//# sourceMappingURL=PushNotificationLogEntity.js.map